export interface Establishment {
  id: string;
  name: string;
  licenseNumber: string;
  expiryDate: string;
  registrationDate: string;
  sector: string;
  status: 'active' | 'inactive' | 'suspended';
  category: string;
  riskLevel: 'low' | 'medium' | 'high';
  address: string;
  phone: string;
  email: string;
  wpsCompliance: 'compliant' | 'non-compliant' | 'pending';
  lastInspection: string;
}

export const mockEstablishments: Establishment[] = [
  {
    id: 'EST001',
    name: 'Al Falah Construction Company',
    licenseNumber: 'LIC123456',
    expiryDate: '2025-12-31',
    registrationDate: '2015-05-10',
    sector: 'Construction',
    status: 'active',
    category: 'Commercial',
    riskLevel: 'medium',
    address: 'Sheikh Zayed Road, Dubai, UAE',
    phone: '+971 4 123 4567',
    email: 'info@alfalahconstruction.ae',
    wpsCompliance: 'compliant',
    lastInspection: '2023-11-15'
  },
  {
    id: 'EST002',
    name: 'Emirates Technology Solutions',
    licenseNumber: 'LIC789012',
    expiryDate: '2026-03-15',
    registrationDate: '2018-01-22',
    sector: 'Information Technology',
    status: 'active',
    category: 'Commercial',
    riskLevel: 'low',
    address: 'Dubai Internet City, Dubai, UAE',
    phone: '+971 4 234 5678',
    email: 'contact@emiratestech.ae',
    wpsCompliance: 'compliant',
    lastInspection: '2023-12-05'
  },
  {
    id: 'EST003',
    name: 'Al Majid Hospitality Group',
    licenseNumber: 'LIC345678',
    expiryDate: '2025-08-20',
    registrationDate: '2010-11-30',
    sector: 'Hospitality',
    status: 'active',
    category: 'Commercial',
    riskLevel: 'low',
    address: 'Jumeirah Beach Road, Dubai, UAE',
    phone: '+971 4 345 6789',
    email: 'info@almajidhospitality.ae',
    wpsCompliance: 'compliant',
    lastInspection: '2024-01-10'
  },
  {
    id: 'EST004',
    name: 'Gulf Manufacturing Industries',
    licenseNumber: 'LIC901234',
    expiryDate: '2025-05-18',
    registrationDate: '2012-07-14',
    sector: 'Manufacturing',
    status: 'active',
    category: 'Industrial',
    riskLevel: 'high',
    address: 'Jebel Ali Industrial Area, Dubai, UAE',
    phone: '+971 4 456 7890',
    email: 'info@gulfmanufacturing.ae',
    wpsCompliance: 'non-compliant',
    lastInspection: '2023-10-22'
  },
  {
    id: 'EST005',
    name: 'Oasis Retail Group',
    licenseNumber: 'LIC567890',
    expiryDate: '2026-01-25',
    registrationDate: '2016-03-08',
    sector: 'Retail',
    status: 'active',
    category: 'Commercial',
    riskLevel: 'medium',
    address: 'Dubai Mall, Downtown Dubai, UAE',
    phone: '+971 4 567 8901',
    email: 'contact@oasisretail.ae',
    wpsCompliance: 'compliant',
    lastInspection: '2023-09-30'
  },
  {
    id: 'EST006',
    name: 'Desert Star Logistics',
    licenseNumber: 'LIC678901',
    expiryDate: '2025-11-12',
    registrationDate: '2014-09-17',
    sector: 'Transportation',
    status: 'active',
    category: 'Commercial',
    riskLevel: 'medium',
    address: 'Al Quoz Industrial Area, Dubai, UAE',
    phone: '+971 4 678 9012',
    email: 'operations@desertstarlogistics.ae',
    wpsCompliance: 'pending',
    lastInspection: '2023-08-15'
  },
  {
    id: 'EST007',
    name: 'Sunrise Healthcare Services',
    licenseNumber: 'LIC234567',
    expiryDate: '2026-04-30',
    registrationDate: '2017-05-22',
    sector: 'Healthcare',
    status: 'active',
    category: 'Medical',
    riskLevel: 'low',
    address: 'Healthcare City, Dubai, UAE',
    phone: '+971 4 789 0123',
    email: 'info@sunrisehealthcare.ae',
    wpsCompliance: 'compliant',
    lastInspection: '2024-02-05'
  },
  {
    id: 'EST008',
    name: 'Al Noor Educational Institute',
    licenseNumber: 'LIC890123',
    expiryDate: '2025-07-15',
    registrationDate: '2013-08-10',
    sector: 'Education',
    status: 'active',
    category: 'Educational',
    riskLevel: 'low',
    address: 'Academic City, Dubai, UAE',
    phone: '+971 4 890 1234',
    email: 'admin@alnooreducation.ae',
    wpsCompliance: 'compliant',
    lastInspection: '2023-11-28'
  },
  {
    id: 'EST009',
    name: 'Marina View Real Estate',
    licenseNumber: 'LIC456789',
    expiryDate: '2025-09-22',
    registrationDate: '2015-12-03',
    sector: 'Real Estate',
    status: 'active',
    category: 'Commercial',
    riskLevel: 'medium',
    address: 'Dubai Marina, Dubai, UAE',
    phone: '+971 4 901 2345',
    email: 'sales@marinaviewrealestate.ae',
    wpsCompliance: 'compliant',
    lastInspection: '2023-10-10'
  },
  {
    id: 'EST010',
    name: 'Golden Sands Tourism',
    licenseNumber: 'LIC012345',
    expiryDate: '2026-02-18',
    registrationDate: '2016-06-15',
    sector: 'Tourism',
    status: 'active',
    category: 'Commercial',
    riskLevel: 'low',
    address: 'Deira, Dubai, UAE',
    phone: '+971 4 012 3456',
    email: 'info@goldensandstourism.ae',
    wpsCompliance: 'compliant',
    lastInspection: '2024-01-20'
  }
];

export const searchEstablishments = (query: string): Establishment[] => {
  const lowerCaseQuery = query.toLowerCase();
  return mockEstablishments.filter(
    (establishment) =>
      establishment.name.toLowerCase().includes(lowerCaseQuery) ||
      establishment.licenseNumber.toLowerCase().includes(lowerCaseQuery) ||
      establishment.sector.toLowerCase().includes(lowerCaseQuery)
  );
};